import type { $Fetch } from 'nitropack'

import type { ResultGenericVM } from '@/view-models/common'
import { type FregionRegionDetectData, type RegionDetectParams } from '@/view-models/region'

import { adaptObjectToSearchParams } from '@/utils/apiAdapter'

export async function getRegionDetect(fetch: $Fetch, params: RegionDetectParams) {
  const res = await fetch<ResultGenericVM<FregionRegionDetectData>>('/region-detect', {
    query: Object.fromEntries(adaptObjectToSearchParams(params)),
  })

  return res
}
